// extracted by mini-css-extract-plugin
module.exports = {"articleList":"support-page-module--articleList--3UXLd","articleItem":"support-page-module--articleItem--3canY"};